module.exports = __webpack_public_path__ + "static/media/img1.5a5bfca8.jpeg";